import { render, staticRenderFns } from "./RegionCreate.vue?vue&type=template&id=3ab78000&scoped=true"
import script from "./RegionCreate.vue?vue&type=script&lang=ts"
export * from "./RegionCreate.vue?vue&type=script&lang=ts"
import style0 from "./RegionCreate.vue?vue&type=style&index=0&id=3ab78000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab78000",
  null
  
)

export default component.exports